import { SwiperComponent } from 'swiper/angular';

import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  MobileDetectService,
  RouterService,
  ShareModalService,
  UserModel,
  UserService,
} from '@lib/gc-common';
import { environment } from '@libs/gc-common/environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'mip-profile-invite',
  templateUrl: './profile-invite.component.html',
  styleUrls: ['./profile-invite.component.scss'],
})
export class ProfileInviteComponent implements OnInit, OnDestroy {
  @ViewChild('swiper', {
    static: false,
  })
  swiper: SwiperComponent;

  profile: UserModel = null;
  slideIndex = 0;

  config = {
    pagination: true,
    // autoHeight: true,
    // allowTouchMove: false,
    navigation: {
      nextEl: '.__button-next',
    },
  };

  routerSubscription = null;
  assetsPath = environment.assetsPath;

  isDesktop = false;

  constructor(
    private shareModalService: ShareModalService,
    private routerService: RouterService,
    private userService: UserService,
    private translate: TranslateService,
    private mobileDetect: MobileDetectService,
  ) {
    this.isDesktop = !this.mobileDetect.isMobile();
    this.routerSubscription = this.routerService.onRouteChange().subscribe(async (route) => {
      try {
        if (!route.params.userId) {
          throw new Error(`The user ID must be provided.`);
        }
        this.profile = await this.userService.getUser(route.params.userId);
      } catch (e) {
        this.routerService.navigateTo('/404');
      }
    });
  }

  ngOnInit(): void {}

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  shareInvite() {
    try {
      if (!this.profile.referralCode) {
        throw new Error(`User does not have a referral code`);
      }

      this.translate.get('profile.invite.share-text').subscribe((translation) => {
        this.shareModalService.shareOpen({
          url: `/@${this.profile.username}/invite/${this.profile.referralCode}`,
          text: translation,
          imageLeft: this.profile.getAvatarSource(),
        });
      });
    } catch (e) {
      throw e;
    }
  }

  onSlideChange() {
    // console.log('profile-invite.component->onSlideChange(): this.slideIndex', this.slideIndex);
  }

  slidePrev() {
    this.swiper.swiperRef.slidePrev();
    this.slideIndex = 0;
  }

  slideNext() {
    this.swiper.swiperRef.slideNext();
    this.slideIndex = 1;
  }
}
